// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_Fhe","cls2":"ReportList-cls2_jcV ReportList-cls1_Fhe"};